module.exports = "mat-radio-button{margin-left:10px}\n"